import type { ReactNode } from 'react';
import { UserOccupation } from 'src/common/constants/user';
export enum CopyType {
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
}
export type ModalCopy = Record<UserOccupation, {
  title: ReactNode;
  subtitle: ReactNode;
}>;
const DEFAULT_TITLE = (isPremium = false) => <>
    <span>{!isPremium ? '30' : '40'}% off</span> Certifications: Prove Your Skills. Launch Your Cyber security Career.
  </>;
const OTHER_CARRERS_COPY = 'Build your future in cyber security: certify your skills today.';
const STUDENTS_COPY = 'Train, certify, and get career-ready in cyber security.';
const IT_PRACTITIONER_COPY = 'Transform your hands-on experience into verified cyber credentials.';
const CYBER_PRACTITIONER_COPY = 'Stay competitive with verified cyber credentials.';
export const MODAL_COPIES: Record<CopyType, ModalCopy> = {
  [CopyType.FREE]: {
    [UserOccupation.STUDENT]: {
      title: DEFAULT_TITLE(),
      subtitle: STUDENTS_COPY
    },
    [UserOccupation.IT_PRACTITIONER]: {
      title: DEFAULT_TITLE(),
      subtitle: IT_PRACTITIONER_COPY
    },
    [UserOccupation.CYBER_PRACTITIONER]: {
      title: DEFAULT_TITLE(),
      subtitle: CYBER_PRACTITIONER_COPY
    },
    [UserOccupation.NONE]: {
      title: DEFAULT_TITLE(),
      subtitle: OTHER_CARRERS_COPY
    },
    [UserOccupation.MANAGER]: {
      title: DEFAULT_TITLE(),
      subtitle: OTHER_CARRERS_COPY
    },
    [UserOccupation.DIRECTOR]: {
      title: DEFAULT_TITLE(),
      subtitle: OTHER_CARRERS_COPY
    },
    [UserOccupation.OTHER]: {
      title: DEFAULT_TITLE(),
      subtitle: OTHER_CARRERS_COPY
    }
  },
  [CopyType.PREMIUM]: {
    [UserOccupation.STUDENT]: {
      title: DEFAULT_TITLE(true),
      subtitle: STUDENTS_COPY
    },
    [UserOccupation.IT_PRACTITIONER]: {
      title: DEFAULT_TITLE(true),
      subtitle: IT_PRACTITIONER_COPY
    },
    [UserOccupation.CYBER_PRACTITIONER]: {
      title: DEFAULT_TITLE(true),
      subtitle: CYBER_PRACTITIONER_COPY
    },
    [UserOccupation.NONE]: {
      title: DEFAULT_TITLE(true),
      subtitle: OTHER_CARRERS_COPY
    },
    [UserOccupation.MANAGER]: {
      title: DEFAULT_TITLE(true),
      subtitle: OTHER_CARRERS_COPY
    },
    [UserOccupation.DIRECTOR]: {
      title: DEFAULT_TITLE(true),
      subtitle: OTHER_CARRERS_COPY
    },
    [UserOccupation.OTHER]: {
      title: DEFAULT_TITLE(true),
      subtitle: OTHER_CARRERS_COPY
    }
  }
};
export const getModalCopy = (type: CopyType, occupation?: string) => {
  const isPremium = type === CopyType.PREMIUM;
  if (!occupation) {
    return {
      title: DEFAULT_TITLE(isPremium),
      subtitle: OTHER_CARRERS_COPY
    };
  }
  return MODAL_COPIES[type][occupation as UserOccupation];
};